import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { IEngine, IGeometry, IMaterial, IPhysicalData, IProject, IProjectInfo, IScenario } from '../../shared/iProject';
import { EReduxState } from '../enum';
import { IReduxState } from '../interface';

const initialState: IReduxState<IProject> = {
    status: EReduxState.initialState,
};

export interface ISetScenario {
    index: number;
    scenario: IScenario;
}

export interface ISetEngine {
    index: number;
    engine: IEngine;
}

export const projectSlice = createSlice({
    name: 'project',
    initialState,
    reducers: {
        cleanProject: state => {
            state.status = EReduxState.initialState;
            state.data = undefined;
        },
        setProject: (state, action: PayloadAction<IProject>) => {
            state.status = EReduxState.fulfilled;
            state.data = action.payload;
        },
        setProjectInfo: (state, action: PayloadAction<IProjectInfo>) => {
            state.status = EReduxState.fulfilled;
            state.data = { ...state.data, project: { ...state.data?.project, ...action.payload } };
        },
        setGeometry: (state, action: PayloadAction<IGeometry>) => {
            state.status = EReduxState.fulfilled;
            state.data = {
                ...state.data,
                geometry: action.payload,
            };
        },
        setMaterial: (state, action: PayloadAction<IMaterial>) => {
            state.status = EReduxState.fulfilled;
            state.data = {
                ...state.data,
                material: action.payload,
            };
        },
        setPhysicalData: (state, action: PayloadAction<IPhysicalData>) => {
            state.status = EReduxState.fulfilled;
            state.data!.material!.physicalData[0] = action.payload;
        },
        setMaterialDoubleLayer: (state, action: PayloadAction<IMaterial>) => {
            state.status = EReduxState.fulfilled;
            state.data!.doubleLayerMaterial = action.payload;
        },
        removeMaterialDoubleLayer: state => {
            state.status = EReduxState.fulfilled;
            state.data!.doubleLayerMaterial = undefined;
        },
        setScenario: (state, action: PayloadAction<ISetScenario>) => {
            state.status = EReduxState.fulfilled;
            state.data!.scenarios![action.payload.index] = action.payload.scenario;
        },
        newScenario: state => {
            state.status = EReduxState.fulfilled;
            state.data!.scenarios!.push({ ...state.data!.scenarios![0], id: undefined });
        },
        removeScenario: (state, action: PayloadAction<number>) => {
            state.status = EReduxState.fulfilled;
            state.data!.scenarios = state.data?.scenarios?.filter((x, i) => i! != action.payload);
        },
        setEngine: (state, action: PayloadAction<ISetEngine>) => {
            state.status = EReduxState.fulfilled;
            state.data!.engines![action.payload.index] = action.payload.engine;
        },
        newEngine: state => {
            state.status = EReduxState.fulfilled;
            state.data!.engines!.push({ ...state.data!.engines![0], id: undefined });
        },
        removeEngine: (state, action: PayloadAction<number>) => {
            state.status = EReduxState.fulfilled;
            state.data!.engines = state.data?.engines?.filter((x, i) => i! != action.payload);
        },
    },
});

export const {
    setProjectInfo,
    setMaterialDoubleLayer,
    setEngine,
    newEngine,
    removeEngine,
    setPhysicalData,
    setScenario,
    removeScenario,
    removeMaterialDoubleLayer,
    setProject,
    setMaterial,
    newScenario,
    setGeometry,
    cleanProject,
} = projectSlice.actions;

export const selectProject = (state: RootState) => state.project;

export default projectSlice.reducer;
